var dataLayerConfig = {
  /**
   * Whether debug details should be output to the browser console
   *
   * @var {boolean}
   */
  shouldDebug: false,
  /**
   * Whether we should throw errors when something goes wrong, or just output to console via `console.error`
   *
   * @var {boolean}
   */
  shouldThrowErrors: false
};
export default dataLayerConfig;